import { useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_NEXT_NUMBER_MEMBER_IN_MANDATE } from "../Schema/Member";

export const useGetNextNumberingMemberInMandate = () => {
  const { refetch, data } = useQuery(GET_NEXT_NUMBER_MEMBER_IN_MANDATE);
  useEffect(() => {
    refetch();
  }, []);
  return { numbering: data?.getNextNumberingMemberInMandate, refetch };
};
